import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken, { getSessionToken } from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { textAnalysisTemplate } from 'containers/TextAnalysis/Template'

const { toolName, userType, source } = textAnalysisTemplate

const axios = (extraParams: any = {}) => {
  const token =
    process.env.NODE_ENV === 'production' ? getSessionToken() : getToken()

  return AxiosInitializer({
    token,
    transformResConfig: false,
    paramsSerializerConfig: true,
    ...extraParams,
    tool: toolName,
  })
}

type DefaultParams = {
  user_type: string
  source_id?: string
}

const defaultParams: DefaultParams = {
  user_type: userType,
}

const dataEndPoint = {
  getApplicationId: ({ source_id }: any) => {
    const queryParams = {
      source_id,
      attributes: { name: source },
    }
    return axios().get('applications', {
      params: { ...defaultParams, ...queryParams },
    })
  },
  getApplicationConfig: ({ source_id, appId }: any) => {
    const queryParams = {
      source_id,
      attributes: { scope: { type: 'application' } },
    }
    return axios().get(`applications/${appId}/configurations`, {
      params: { ...defaultParams, ...queryParams },
    })
  },
  getSourceId: ({ source_id, appId }: any) => {
    const queryParams = {
      source_id,
      attributes: { tenant_id: source_id },
    }
    return axios().get(`applications/${appId}/sources`, {
      params: { ...defaultParams, ...queryParams },
    })
  },
  getSourceOwnerConfig: ({
    site_id,
    appId,
    sourceId,
    source,
    owner_id,
  }: any) => {
    const queryParams: any = {
      source_id: site_id,
      attributes: { scope: { type: source } },
    }
    if (source === 'owner') {
      queryParams.attributes.scope.id = owner_id
    }
    const path = `applications/${appId}/sources/${sourceId}/configurations`
    return axios().get(path, {
      params: { ...defaultParams, ...queryParams },
    })
  },
  createOwnerConfig: ({ site_id, appId, sourceId, owner_id }: any) => {
    defaultParams['source_id'] = site_id
    const queryParams = {
      scope: {
        id: owner_id,
        type: 'owner',
      },
      configurations: {
        features: [
          { type: 'sentiment', status: false },
          { type: 'themes_keyphrases', status: false },
        ],
      },
    }
    const path = `applications/${appId}/sources/${sourceId}/configurations`
    return axios().post(path, queryParams, {
      params: defaultParams,
    })
  },
  updateOwnerConfig: ({
    site_id,
    appId,
    sourceId,
    configId,
    features,
  }: any) => {
    defaultParams['source_id'] = site_id
    const queryParams = { configurations: { features } }
    const path = `applications/${appId}/sources/${sourceId}/configurations/${configId}`
    return axios().patch(path, queryParams, {
      params: defaultParams,
    })
  },
}

const taApplicationDataAPI = {
  getApplicationId: (params = {}) =>
    apiWrapper({
      endPoint: dataEndPoint.getApplicationId,
      params,
    }),
  getApplicationConfig: (params = {}) =>
    apiWrapper({
      endPoint: dataEndPoint.getApplicationConfig,
      params,
    }),
  getSourceId: (params = {}) =>
    apiWrapper({
      endPoint: dataEndPoint.getSourceId,
      params,
    }),
  getSourceOwnerConfig: (params = {}) =>
    apiWrapper({
      endPoint: dataEndPoint.getSourceOwnerConfig,
      params,
    }),
  createOwnerConfig: (params = {}) =>
    apiWrapper({
      endPoint: dataEndPoint.createOwnerConfig,
      params,
    }),
  updateOwnerConfig: (params = {}) =>
    apiWrapper({
      endPoint: dataEndPoint.updateOwnerConfig,
      params,
    }),
}

export default taApplicationDataAPI
